<template>
  <div
    class="card-container m-1"
    :style="stylesCard"
    @mouseover="isHovered = true"
    @mouseout="isHovered = false"
  >
    <b-row>
      <b-col cols="12" class="d-flex">
        <span class="d-flex">
          <p class="title mr-auto">
            {{ $t(data.title) }}
          </p>
        </span>
        <svg
          v-if="data.icon == 1"
          xmlns="http://www.w3.org/2000/svg"
          stroke-width="1.5"
          :stroke="isDarkTheme ? '#ffffff' : '#000000'"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="40"
          class="icon-bg"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M15 11v.01" />
          <path d="M5.173 8.378a3 3 0 1 1 4.656 -1.377" />
          <path
            d="M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3h0z"
          />
        </svg>

        <svg
          v-if="data.icon == 2"
          xmlns="http://www.w3.org/2000/svg"
          stroke-width="1.5"
          :stroke="isDarkTheme ? '#ffffff' : '#000000'"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="40"
          class="icon-bg"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3"
          />
          <path d="M16 3v4" />
          <path d="M8 3v4" />
          <path d="M4 11h12.5" />
          <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
          <path d="M19 21v1m0 -8v1" />
        </svg>
      </b-col>
      <b-col cols="12" class="d-flex" v-if="data.subtotal > 0">
        <div class="mr-auto bolderx" style="font-size: 13px">Subtotal</div>
        <div
          class="value-indicator"
          :class="
            data.subtotal > 0
              ? 'text-primary'
              : data.subtotal < 0
              ? 'text-danger'
              : ''
          "
        >
          {{ data.subtotal | currencyZero }}
        </div>
      </b-col>
      <b-col cols="12" class="d-flex">
        <div class="mr-auto bolderx" style="font-size: 13px">Total</div>
        <div
          class="value-indicator"
          :class="
            data.total > 0
              ? 'text-primary'
              : data.total < 0
              ? 'text-danger'
              : ''
          "
        >
          S/, {{ data.total | currencyZero }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isDarkTheme() {
      return this.$store.state.appConfig.layout.skin == "dark";
    },
    stylesCard() {
      const bg = this.isDarkTheme ? "#222222" : "#F3F2F7";
      const color = this.isDarkTheme ? "#B2B1B1" : "#616161";
      const style = {
        background: bg,
        color: color,
        boxShadow: this.isDarkTheme
          ? "1px 2px 2px 0 #222222"
          : "0px 1px 2px 0 #888888",
      };
      return style;
    },
  },

  data() {
    return {
      selected: false,
      isHovered: false,
    };
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  padding: 4% 5% 0 5%;
  overflow: hidden;
  border-radius: 10px;
  height: 110px;
}

.title {
  font-weight: bold !important;
  display: inline-block;
  font-size: 15px;
}

.icon-bg {
  position: absolute;
  top: -12%;
  right: 2%;
  width: 30px;
  height: 30px;
}

.value-indicator {
  font-weight: bold !important ;
  font-size: 15px;
}

.bolderx {
  font-weight: bold !important ;
}
.button-indicator {
  position: absolute;
  top: 80%;
  left: 65%;
}
.alert-icon-circle-card {
  margin-left: 5px;
  margin-top: 1px;
}
</style>
